module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "custom-new-slider"
  }, [_c('Slider2', {
    staticStyle: {
      "z-index": "9",
      "margin": "auto"
    },
    attrs: {
      "height": "100%",
      "width": "100%",
      "auto": false
    }
  }, [_vm._l((_vm.list), function(i, index) {
    return _c('SliderItem', {
      key: index,
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "slider-real",
      style: ({
        backgroundImage: 'url(' + i.backgroundimage + ')'
      })
    }), _c('div', {
      staticClass: "slider-real__title"
    }, [_vm._v(_vm._s(i.title))]), _c('div', {
      staticClass: "slider-real__body"
    }, [_vm._v(_vm._s(i.body))]), _c('div', {
      staticClass: "slider-real__author"
    }, [_vm._v(_vm._s(i.name))])])
  }), _vm._l((_vm.list), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "slider-selector",
      attrs: {
        "slot": "indicators"
      },
      slot: "indicators"
    }, [_c('div', {
      staticClass: "slider-selector__background",
      class: {
        active: index === _vm.$store.state.types
      },
      style: ({
        backgroundImage: 'url(' + i.backgroundimage + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.whatAmI(index)
        }
      }
    })])
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3637290e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-new-slider/custom-new-slider.pug
// module id = 578
// module chunks = 1